import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import HeroArticle from "../../components/hero/HeroArticle";
import BreadcrumbsArticle from "../../components/navigation/BreadcrumbsArticle";

const WorshipArticleLayout = ({
                                  title,
                                  subtitle,
                                  children,
                                  primaryCta,
                                  secondaryCta
                              }) => {
    return (
        <>
            {/* =====================================================
              Hero Section
             ===================================================== */}
            <HeroArticle title={title} subtitle={subtitle} />

            {/* Subtle divider between hero and content */}
            <div className="article-hero-divider" />

            <BreadcrumbsArticle
                items={[
                    { label: "Home", href: "/" },
                    { label: "Worship", href: "/worship" },
                    { label: title }
                ]}
            />

            {/* =====================================================
              Article Content
              ===================================================== */}
            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg="8" className="article-content">

                            {/* Main article body */}
                            {children}

                            {/* -------------------------------------------------
                  Soft CTA (Guidance)
                 ------------------------------------------------- */}
                            {secondaryCta && (
                                <div className="mt-5 p-4 bg-secondary rounded border-left border-primary">
                                    <h5
                                        style={{fontSize: '0.9rem'}}
                                        className="text-primary text-uppercase pb-2 mb-2"
                                    >
                                        {secondaryCta.title}
                                    </h5>

                                    <p className="mb-3 text-muted">
                                        {secondaryCta.text}
                                    </p>

                                    <a
                                        href={secondaryCta.href}
                                        className="text-primary font-weight-bold"
                                    >
                                        {secondaryCta.label} →
                                    </a>
                                </div>
                            )}

                            {/* -------------------------------------------------
                  Primary CTA (Action)
                 ------------------------------------------------- */}
                            {primaryCta && (
                                <div className="mt-6 text-center">
                                    <h4 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3 font-weight-bold mb-2">
                                        {primaryCta.title}
                                    </h4>
                                    <p className="text-muted mb-3">
                                        You don’t need to have everything planned — just begin.
                                    </p>
                                    <Button
                                        color="primary"
                                        size="lg"
                                        href={primaryCta.href}
                                    >
                                        {primaryCta.label}
                                    </Button>
                                </div>
                            )}

                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default WorshipArticleLayout;